import React from "react";
import {
  Flex,
  Text,
  Box,
} from "@chakra-ui/react";
import ReactApexChart from "react-apexcharts";
import Card from "components/Card/Card";
import ExportButton from "components/Reports/ExportCSV";

const PaidCommissionsChart = ({
  data = [],
  loading,
}) => {
  if (loading) return null;

  const sortedData = [...data].sort(
    (a, b) =>
      new Date(a.date) -
      new Date(b.date)
  );

  const labels = sortedData.map((item) =>
    new Date(item.date).toLocaleDateString(
      "en-US",
      {
        month: "short",
        day: "numeric",
      }
    )
  );

  const values = sortedData.map(
    (item) =>
      item.amount ||
      item.total_paid ||
      item.commission ||
      0
  );

  const chartOptions = {
    chart: {
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    xaxis: {
      categories: labels,
      labels: {
        style: {
          colors: "#071D54",
        },
      },
      title: {
        text: "Date",
        style: {
          color: "#071D54",
        },
      },
    },

    yaxis: {
      labels: {
        style: {
          colors: "#071D54",
        },
        formatter: (val) =>
          `P${val.toLocaleString()}`,
      },
      title: {
        text: "Commission Paid",
        style: {
          color: "#071D54",
        },
      },
    },

    stroke: {
      curve: "smooth",
      width: 3,
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },

    colors: ["#60A5FA"],

    dataLabels: {
      enabled: false,
    },

    grid: {
      borderColor: "#334155",
      strokeDashArray: 4,
    },

    tooltip: {
      theme: "dark",
      y: {
        formatter: (val) =>
          `P${val.toLocaleString()}`,
      },
    },
  };

  const series = [
    {
      name: "Paid",
      data: values,
    },
  ];

  const exportData = sortedData.map(
    (item) => ({
      Date: item.date,
      Partner:
        item.partner_name ||
        item.partner,
      Amount:
        item.amount ||
        item.total_paid,
    })
  );

  return (
    <Card
      py="1rem"
      height="400px"
      width="100%"
      bg="white"
      position="relative"
    >
      <Box
        position="absolute"
        top="12px"
        right="12px"
        zIndex="2"
      >
        <ExportButton
          data={exportData}
          fileName="paid_commissions"
        />
      </Box>

      <Flex
        px={5}
        pt={2}
      >
        <Text
          color="#071D54"
          fontWeight="bold"
          fontSize="lg"
        >
          Paid Commissions Trend
        </Text>
      </Flex>

      <ReactApexChart
        options={chartOptions}
        series={series}
        type="area"
        height="320"
      />
    </Card>
  );
};

export default PaidCommissionsChart;